module.exports = __webpack_public_path__ + "static/panou-verde-50af79179d229496ebf2b75d123d6817.jpg";